// Режимы внесения данных: поля таблицы, справочники и формат запроса как в старых модалках dataEntry/modals

export const NUMBER = /^\d+([.,]\d+)?$/;

export const MODES = {
  formed: {
    title: "Образовалось",
    stepTitle: "Образование",
    actionId: 1,
    icon: "el-icon-circle-plus-outline",
  },
  received: {
    title: "Поступило от",
    stepTitle: "Поступление",
    actionId: 2,
    icon: "el-icon-download",
  },
  transferred: {
    title: "Передано внутри предприятия (иному подразделению)",
    stepTitle: "Передача внутри своего предприятия",
    actionId: 3,
    icon: "el-icon-upload2",
  },
  contractor: {
    title: "Передано контрагенту (вывоз отходов)",
    stepTitle: "Передача контрагенту (вывоз отходов)",
    icon: "el-icon-truck",
  },
  used: {
    title: "Использовано",
    stepTitle: "Использование",
    actionId: 5,
    icon: "el-icon-refresh",
  },
  renderedHarmless: {
    title: "Обезврежено",
    stepTitle: "Обезвреживание",
    actionId: 4,
    icon: "el-icon-first-aid-kit",
  },
  buried: {
    title: "Захоронено",
    stepTitle: "Захоронение на собственном объекте",
    actionId: 6,
    icon: "el-icon-takeaway-box",
  },
  inStorage: {
    title: "Направлено на объект хранения",
    actionTitle: "Направлено на долговременное хранение",
    stepTitle: "Долговременное хранение",
    actionId: 8,
    icon: "el-icon-box",
  },
};

export const INCOMING = ["formed", "received"];
// Режимы расхода - они же дальнейшие действия после поступления (ШАГ 4 ТЗ).
// Сначала движения внутри предприятия, последней - вывоз контрагенту
export const OUTGOING = [
  "transferred",
  "used",
  "renderedHarmless",
  "buried",
  "inStorage",
  "contractor",
];

export const isIncoming = (mode) => INCOMING.includes(mode);

export const round = (value) => Math.round(value * 100000) / 100000;

// Как в dataEntryEdit: кнопки захоронения и хранения видны только при лицензии/лимите
export function isAvailable(type, page) {
  if (type === "buried") return page.organizationWasteBurialLicense !== null;
  if (type === "inStorage")
    return (
      page.organizationWasteStoreLicense !== null ||
      parseFloat(page.organizationWasteStoreLimit) !== -1
    );
  return true;
}

// Справочники, которые нужно загрузить для режима
export const OPTIONS_FOR = {
  received: ["contractors", "pss17"],
  transferred: ["transferOrgs"],
  used: ["pss19"],
  renderedHarmless: ["pss20"],
  buried: ["pss21"],
  inStorage: ["storageOrgs", "pss22"],
  // Контрагенты с действующим договором на дату, как во «Вывозе отходов»
  contractor: ["contractorsByDate"],
};

// Цели и объекты захоронения при передаче контрагенту - как в accompanyingPassport («Вывоз отходов»)
export const DISPOSAL_PURPOSES = [
  { id: 1, name: "С целью использования" },
  { id: 2, name: "С целью обезвреживания" },
  { id: 3, name: "С целью захоронения по договору отчуждения" },
  { id: 4, name: "С целью хранения" },
  { id: 5, name: "Прочее" },
  { id: 6, name: "С целью захоронения без договора отчуждения" },
  { id: 7, name: "С целью заготовки" },
  { id: 8, name: "С целью сортировки" },
];
const BURIAL_WITHOUT_CONTRACT = 6;

const CONTRACTOR_TIP =
  "Выберите контрагента для первой даты — наименование автоматически применится ко всем строкам. При необходимости измените контрагента в любой строке.";

export const BURIAL_OBJECTS = [
  { id: 211, name: "Полигон промышленных отходов" },
  { id: 212, name: "Полигон токсичных промышленных отходов" },
  { id: 221, name: "Полигон твердых коммунальных отходов" },
  { id: 290, name: "Другое" },
];

export const PSS18_TRANSFER_REASONS = [
  { id: 1, name: "С целью использования" },
  { id: 2, name: "С целью обезвреживания" },
  { id: 3, name: "С целью захоронения" },
  { id: 4, name: "С целью хранения" },
  { id: 5, name: "Прочее" },
];

// Как в transferredModal: только Ф/П/У, действующие на дату
function activeOn(list, date) {
  const msPerDay = 1000 * 60 * 60 * 24;
  const day = Math.floor(new Date(date).getTime() / msPerDay) - 1;
  return list.filter((item) => {
    const from = item.dateFrom ? Math.floor(item.dateFrom / msPerDay) : -Infinity;
    const to = item.dateTo ? Math.floor(item.dateTo / msPerDay) : Infinity;
    return from <= day && day <= to;
  });
}

// Выбор Ф/П/У подставляет первый тех. процесс, очистка обнуляет зависимые поля (ТЗ)
function orgChange(clearKeys) {
  return (org) => {
    if (!org) return Object.fromEntries(clearKeys.map((key) => [key, null]));
    return { techProcess: (org.objectList && org.objectList[0]) || null };
  };
}

const techProcessField = (orgKey) => ({
  key: "techProcess",
  label: "Тех. процесс",
  type: "select",
  options: (values) => (values[orgKey] && values[orgKey].objectList) || [],
  disabled: (values) => !values[orgKey],
  required: true,
  cascade: true,
  minWidth: 200,
});

/*
  Поля таблицы для режима. Описание поля:
  key, label, type: select | checkbox | number | text | passport,
  options: массив или (values, date) => массив (для select),
  primary - пустое значение означает «дату не проводить» (если строки можно пропускать),
  required - true или (values) => boolean,
  cascade - значение первой строки подставляется в остальные нетронутые строки
    (у текстового поля - серым, при нажатии на поле подставленное исчезает),
  tip - своя подсказка у заголовка ("" - без подсказки), иначе общая для cascade,
  shortLabel - короткий заголовок узкой колонки (полный - при наведении),
  column - поля с одинаковым column выводятся в одной колонке (заголовок - columnLabel первого),
  hidden: (values) => boolean - поле не показывается в строке (видно другое поле той же колонки),
  onChange: (value, values) => изменения зависимых полей строки,
  disabled: (values) => boolean
*/
export function fieldsFor(type, options) {
  switch (type) {
    case "received":
      return [
        {
          key: "contractorsInfoReceived",
          label: "Контрагент",
          type: "select",
          options: options.contractors,
          disabled: (values) => !!values.receivedFromPerson,
          required: (values) => !values.receivedFromPerson,
          cascade: true,
          minWidth: 220,
          tip: CONTRACTOR_TIP,
        },
        {
          key: "receivedFromPerson",
          label: "Физ. лицо",
          type: "checkbox",
          onChange: (value) => (value ? { contractorsInfoReceived: null } : {}),
          cascade: true,
          width: 100,
          tip: "При получении отходов от физического лица поставьте отметку на первой дате — этот выбор автоматически применится ко всем строкам. При необходимости снимите отметку в любой строке.",
        },
        {
          key: "pss17Info",
          label: "Поступило для",
          type: "select",
          options: options.pss17,
          required: true,
          cascade: true,
          minWidth: 200,
          tip: "Выберите цель получения отходов для первой даты — она автоматически применится ко всем строкам. При необходимости измените значение в любой строке.",
        },
        {
          key: "importstore",
          label: "Из них по импорту",
          type: "number",
          width: 150,
        },
      ];
    case "transferred":
      return [
        {
          key: "organizationInfoTransferredTo",
          label: "Филиал / Подразделение / Участок",
          type: "select",
          options: (values, date) => activeOn(options.transferOrgs, date),
          onChange: orgChange(["techProcess", "pss18Info"]),
          primary: true,
          required: true,
          cascade: true,
          minWidth: 240,
          tip: "Выберите получателя отходов на первой дате — он автоматически применится ко всем строкам. При необходимости измените значение в любой строке.",
        },
        // Тех. процесс получателя не выбирают: подставляется первый при выборе Ф/П/У (замечания)
        {
          key: "pss18Info",
          label: "Цель",
          type: "select",
          options: PSS18_TRANSFER_REASONS,
          disabled: (values) => !values.organizationInfoTransferredTo,
          required: true,
          cascade: true,
          minWidth: 180,
          tip: "Выберите цель передачи отходов для первой даты — она автоматически применится ко всем строкам. При необходимости измените значение в любой строке.",
        },
      ];
    case "used":
      return [
        {
          key: "pss19Info",
          label: "Использовано для",
          type: "select",
          options: options.pss19,
          primary: true,
          required: true,
          cascade: true,
          minWidth: 260,
          tip: "Выберите цель использования отходов для первой даты — она автоматически применится ко всем строкам. При необходимости измените значение в любой строке.",
        },
      ];
    case "renderedHarmless":
      return [
        {
          key: "pss20Info",
          label: "Способ обезвреживания отхода",
          type: "select",
          options: options.pss20,
          primary: true,
          required: true,
          cascade: true,
          minWidth: 260,
          tip: "Выберите способ обезвреживания отходов для первой даты — он автоматически применится ко всем строкам. При необходимости измените значение в любой строке.",
        },
      ];
    case "buried":
      return [
        {
          key: "pss21Info",
          label: "Объект захоронения отходов",
          type: "select",
          options: options.pss21,
          onChange: (value) => (value ? {} : { passport: null }),
          primary: true,
          required: true,
          cascade: true,
          minWidth: 260,
        },
        {
          key: "passport",
          label: "Сопроводительный паспорт",
          type: "passport",
          disabled: (values) => !values.pss21Info,
          width: 210,
        },
      ];
    case "inStorage":
      return [
        {
          key: "organizationInfoSentForStorageTo",
          label: "Филиал / Подразделение / Участок",
          type: "select",
          options: options.storageOrgs,
          onChange: orgChange(["techProcess", "pss22Info"]),
          primary: true,
          required: true,
          cascade: true,
          minWidth: 240,
        },
        techProcessField("organizationInfoSentForStorageTo"),
        {
          key: "pss22Info",
          label: "Наименование объекта, места хранения отходов",
          type: "select",
          options: options.pss22,
          disabled: (values) => !values.organizationInfoSentForStorageTo,
          required: true,
          cascade: true,
          minWidth: 240,
        },
      ];
    case "contractor": {
      const noPurpose = (values) => !values.disposal;
      return [
        {
          key: "disposal",
          label: "Передано для",
          type: "select",
          options: DISPOSAL_PURPOSES,
          // Цель убрали - дату не вывозим: остальные поля строки обнуляются (ТЗ)
          onChange: (value) =>
            value
              ? value.id === BURIAL_WITHOUT_CONTRACT
                ? {}
                : { pss21: null }
              : {
                  Contractors: null,
                  receivedFromPerson: false,
                  fio: null,
                  pss21: null,
                  export: false,
                  passport: null,
                },
          primary: true,
          required: true,
          cascade: true,
          minWidth: 190,
        },
        {
          // Физлицо и ФИО переносятся на следующие строки, как остальные поля
          key: "receivedFromPerson",
          label: "Физ. лицо",
          type: "checkbox",
          disabled: noPurpose,
          onChange: (value) =>
            value ? { Contractors: null } : { fio: null },
          cascade: true,
          width: 90,
          tip: "При передаче отходов физическому лицу поставьте отметку на первой дате — этот выбор автоматически применится ко всем строкам. При необходимости снимите отметку в любой строке.",
        },
        // Контрагент и ФИО - одна колонка: в строке видно только одно из них по отметке «Физ. лицо»
        {
          key: "Contractors",
          label: "Контрагент",
          type: "select",
          options: options.contractorsByDate,
          disabled: noPurpose,
          required: (values) => !values.receivedFromPerson,
          hidden: (values) => !!values.receivedFromPerson,
          column: "recipient",
          columnLabel: "Контрагент / ФИО физ. лица",
          cascade: true,
          minWidth: 200,
          tip: CONTRACTOR_TIP,
        },
        {
          key: "fio",
          label: "ФИО физ. лица",
          type: "text",
          required: (values) => !!values.receivedFromPerson,
          hidden: (values) => !values.receivedFromPerson,
          column: "recipient",
          cascade: true,
          tip: "",
        },
        {
          key: "pss21",
          label: "Объект захоронения",
          type: "select",
          options: BURIAL_OBJECTS,
          disabled: (values) =>
            !values.disposal || values.disposal.id !== BURIAL_WITHOUT_CONTRACT,
          required: (values) =>
            !!values.disposal && values.disposal.id === BURIAL_WITHOUT_CONTRACT,
          cascade: true,
          minWidth: 160,
        },
        {
          // Экспорт на следующие строки не переносится (ТЗ)
          key: "export",
          label: "Экспорт",
          type: "checkbox",
          disabled: noPurpose,
          width: 80,
        },
        {
          key: "passport",
          label: "Сопроводительный паспорт",
          type: "passport",
          disabled: noPurpose,
          width: 210,
        },
      ];
    }
    default:
      return [];
  }
}

const toRuDate = (date) => date.split("-").reverse().join(".");

/*
  Запись для /receive/formwaste - формат «Вывоза отходов» (accompanyingPassport.submitForm),
  только поля, которые читает бэкенд (createNewEntryForWasteDeclar).
  amount_of_current_unit должно быть > 0, а exportstore - заполнено: иначе бэкенд молча пропускает запись
*/
export function buildContractorPayload({ date, store, amount, values, tphwId }) {
  const person = !!values.receivedFromPerson;
  const data = toRuDate(date);
  return {
    data,
    disposal: values.disposal.id,
    Contractors: person ? null : values.Contractors.id,
    pss21:
      values.disposal.id === BURIAL_WITHOUT_CONTRACT ? values.pss21.id : null,
    receivedFromPerson: person,
    fio: person ? values.fio : null,
    withLongStore: false,
    tara_name: values.taraName || null,
    tara_vight: values.taraWeight || null,
    // Без номера паспорт не создаётся (createNewpassport вернёт 0)
    passport: values.passport ? { ...values.passport, data } : { data },
    orgs: [
      {
        wastorg: [
          {
            tphw_id: String(tphwId),
            out: String(store),
            amount_of_current_unit: String(amount),
            exportstore: values.export ? String(store) : "0",
          },
        ],
      },
    ],
  };
}

export const isEmpty = (value) =>
  value === null || value === undefined || value === "";

// Состояние строки: skip - дату не проводить, errors - незаполненные/неверные поля
export function rowStatus(fields, values = {}, skippable = false) {
  const primary = fields.filter((field) => field.primary);
  const skip =
    skippable &&
    primary.length > 0 &&
    primary.every((field) => isEmpty(values[field.key]));
  const errors = {};
  if (!skip) {
    fields.forEach((field) => {
      const value = values[field.key];
      const required =
        typeof field.required === "function"
          ? field.required(values)
          : field.required;
      if (required && isEmpty(value)) errors[field.key] = true;
      if (field.type === "number" && !isEmpty(value) && !NUMBER.test(value))
        errors[field.key] = true;
    });
  }
  return { skip, errors, valid: !Object.keys(errors).length };
}

// Тело запроса receive/form для одной даты
export function buildPayload(type, { date, store, amount, values, unitId }) {
  const base = { amount, store, date };
  // Бэкенд берёт тех. процесс получателя из objectList[0]: не выбран - первый у Ф/П/У
  const withTechProcess = (org) => {
    const techProcess =
      values.techProcess || (org.objectList && org.objectList[0]) || null;
    return { ...org, objectList: techProcess ? [techProcess] : [] };
  };
  switch (type) {
    case "formed":
      return base;
    case "received":
      return {
        ...base,
        receivedFromPerson: !!values.receivedFromPerson,
        contractorsInfoReceived: values.receivedFromPerson
          ? null
          : values.contractorsInfoReceived,
        pss17Info: values.pss17Info,
        importstore: isEmpty(values.importstore)
          ? "0"
          : String(values.importstore).replace(",", "."),
      };
    case "transferred":
      return {
        ...base,
        organizationInfoTransferredTo: withTechProcess(
          values.organizationInfoTransferredTo
        ),
        pss18Info: values.pss18Info,
        transferredFromUnitId: unitId,
      };
    case "used":
      return { ...base, pss19Info: values.pss19Info };
    case "renderedHarmless":
      return { ...base, pss20Info: values.pss20Info };
    case "buried":
      return values.passport
        ? { ...base, pss21Info: values.pss21Info, passport: values.passport }
        : { ...base, pss21Info: values.pss21Info };
    case "inStorage":
      return {
        ...base,
        organizationInfoSentForStorageTo: withTechProcess(
          values.organizationInfoSentForStorageTo
        ),
        pss22Info: values.pss22Info,
        transferredFromUnitId: unitId,
      };
    default:
      throw new Error("Неизвестный режим " + type);
  }
}

// Пустой сопроводительный паспорт, как в buriedModal/usedModal
export function emptyPassport() {
  return {
    number: null,
    contractor1: null,
    contractor2: { content: 0 },
    contractor3: null,
    data: null,
    vehicle: null,
    full_name: null,
    tara_name: null,
    tara_vight: null,
    vehicle_vight: null,
    number_card: null,
    owner: null,
    ownerr: null,
    transfer: null,
    transferr: null,
    ca1: "Ручной ввод",
    contractor1r: null,
    ca2: "Ручной ввод",
    contractor2r: null,
    ca3: "Ручной ввод",
    contractor3r: null,
    egr_full_name: null,
    chek_null_value: false,
    fileType: ".pdf",
    tr: "Ответственное лицо",
    ow: "Ответственное лицо",
    rules: {
      rul: [{ required: true, message: "Заполните поле", trigger: "blur" }],
    },
  };
}
